import React from 'react';
import {FaGithub, FaLinkedin} from "react-icons/fa";
import {GrMail} from "react-icons/gr";
import {SiWhatsapp , SiTelegram} from "react-icons/si"

const Footer = () => {
  return (
    <footer>
      <h4>Developed by MOHAMED GAMAL</h4>
      <h4>Copyright &copy; 2024 MG</h4>
      <div className='footerLinks'>
        <a href="https://github.com/EngGemy95" target='_blank'><FaGithub/></a>
        <a href="https://www.linkedin.com/in/mohamed-gamal-a48054b9/" target='_blank'><FaLinkedin/></a>
        <a href='mailto:mohamed.gamalfayed@gmail.com' target='_blank'><GrMail/></a>
        <a href="https://wa.me/201009973789" target="_blank"><SiWhatsapp/></a>
        <a href="https://t.me/Gemy95" target="_blank"><SiTelegram/></a>
      </div>
    </footer>
  )
}

export default Footer